// extracted by mini-css-extract-plugin
export default {"test_card":"PartWorkAdminUsed_test_card__+K6R1","btn_print":"PartWorkAdminUsed_btn_print__RQ0WD","div_print":"PartWorkAdminUsed_div_print__lRC88"};